import {useInjection} from "inversify-react";
import {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {CategoryApi, CategoryCreateDto, CategoryDto, CategoryUpdateDto} from "../../api";
import CategorysList from "./categoryList";
import CategoryModalFormAddContainer from "./categoryModalFormAddContainer/categoryModalFormAddContainer";
import {Button, Layout} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "./categoryListContainer.module.scss";
import {useNavigate, useParams} from "react-router-dom";

export default function CategoriesListContainer() {

    const navigate = useNavigate();
    const apiService = useInjection(ApiService);
    const [categories, setCategories] = useState<CategoryDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [categoryModalFormContainerTitle, setCategoryModalFormContainerTitle] = useState<string>();
    const [categoryToEdit, setCategoryToEdit] = useState<CategoryUpdateDto | null>(null);
    const [idCategoryToEdit, setIdCategoryToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    let {categoryId} = useParams();

    const refreshCategoriesList = async () => {
        setIsLoading(true);
        try {
            if (categoryId) {
                const categories = await apiService.getApi(CategoryApi)
                    .apiCategorySubcategoriesCategoryIdGet(+categoryId);
                setCategories(categories.data);
            } else {
                const categories = await apiService.getApi(CategoryApi)
                    .apiCategoryParentCategoriesGet();
                setCategories(categories.data);
            }
        } catch (e: any) {
            console.log(e.response.data);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        refreshCategoriesList();
    }, [categoryId])

    const onAddClicked = () => {
        setCategoryModalFormContainerTitle("Dodaj nową kategorię");
        setCategoryToEdit(null);
        setIdCategoryToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = async (id: number) => {
        setCategoryModalFormContainerTitle(`Edytuj kategorię: ${id}`);
        setIsLoading(true);

        const response = await apiService.getApi(CategoryApi).apiCategoryIdGet(id);

        setCategoryToEdit(response.data as CategoryUpdateDto);
        setIdCategoryToEdit(id);
        setAddFormVisible(true);
        setIsLoading(false);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(CategoryApi).apiCategoryIdDelete(id);
        if (response.request.status !== 200) {
            console.log("Error occured while deleting data"); //add some warning?
        } else {
            refreshCategoriesList();
        }
    }

    const onSubmit = async (values: CategoryCreateDto | CategoryUpdateDto) => {
        try {
            if (categoryToEdit === null) {
                if (categoryId) values.parentCategoryId = +categoryId!
                await apiService.getApi(CategoryApi).apiCategoryPost(values);
            } else if (idCategoryToEdit !== null) {
                values.parentCategoryId = categoryToEdit.parentCategoryId;
                await apiService.getApi(CategoryApi).apiCategoryIdPut(idCategoryToEdit, values)
            }
        } catch (e: any) {
            return e.response.data;
        }

        setAddFormVisible(false)
        refreshCategoriesList();
    }

    return <Layout>
        <Content className={styles.content}>
            <CategorysList
                data={categories || null}
                onAddClicked={onAddClicked}
                onEditClicked={onEditClicked}
                onDeleteClicked={onDeleteClicked}
            />
            <CategoryModalFormAddContainer
                onFinish={() => setAddFormVisible(false)}
                onSubmit={onSubmit}
                addFormVisibility={isAddFormVisible}
                title={categoryModalFormContainerTitle || ""}
                CategoryToEdit={categoryToEdit}
            />
            <Button style={{marginTop: "1rem"}} onClick={() => navigate(-1)}>
                Wróć
            </Button>
        </Content>
    </Layout>;
}
